import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface SmartSwapModalPayload {
  data?: null;
  type: ModalType.SmartSwap;
  isOpen?: boolean;
}

export const SmartSwapModal = React.forwardRef<
  HTMLElement,
  Pick<SmartSwapModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Smart-Swap"
      subtitle="Upgrade Old Tokens into Native $CRAT"
      icon={<Icons.SmartSwapDark />}
      link={{
        title: 'Swap Smarter',
        link: {
          href: ECOSYSTEM_LINKS.smartSwap,
          text: ECOSYSTEM_LINKS.smartSwap,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Smart-Swap is a conversion bridge for early supporters.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It allows holders of pre-sale or ICO tokens (like CRAT Token or CratD2C-Pre) to swap them into the main $CRAT
        coin under clear rules and vesting schedules.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        This ensures a smooth transition from earlier fundraising stages into the live MainNet economy.
      </Typography>
    </ModalSidebar>
  );
});
